import { tableFrCATranslations } from "../components/table/_lang/fr-CA";
import { draftFrCATranslations } from "../hooks/_lang/fr-CA";
import type { RayaLucariaTranslationKey } from "./en-US";

export const rayaLucariaFrCA: Record<RayaLucariaTranslationKey, string> = {
  ...tableFrCATranslations,
  ...draftFrCATranslations,
  apply: "Appliquer",
  cancel: "Annuler",
  clear: "Effacer",
  confirm: "Confirmer",
  filter: "Filtrer",
};
